import { InstantPayTutorialStep } from "components/Tutorials/InstantPayTutorial.tsx/InstantPayTutorial";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";

interface IStepIndicatorsProps {
  steps: Array<any>;
  selectedStep?: InstantPayTutorialStep;
  lastCompletedStep: number;
}

const StepIndicators: React.FC<IStepIndicatorsProps> = ({
  steps,
  lastCompletedStep,
}) => {
  const isStepCompleted = (stepId: number) => lastCompletedStep >= stepId;
  return (
    <div className=" flex gap-2 justify-center">
      {steps?.map((step) => (
        <>
          {isStepCompleted(step.id) ? (
            <FaCheckCircle
              className={`text-xl text-primary justify-end align-self-end flex`}
            />
          ) : (
            <FaRegCheckCircle
              className={`text-xl text-black60 justify-end align-self-end flex`}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default StepIndicators;
